var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    transitOptions,
    isLdpCollapseEnabled,
    fullLdpModules
  } = options;

__p+='\n';
 
  let abAccordionClass = '' , 
      abTitleClass = '',
      abIconClass = '';

__p+='\n';
 
  if (fullLdpModules === 'V1' || fullLdpModules === 'V2') {
    abAccordionClass = 'full-ldp-collasped-accordion';
    abTitleClass = 'full-ldp-collasped-title-section';
    abIconClass = 'icon-space-right';
} 

__p+='\n\n';
 if (isLdpCollapseEnabled) { 
__p+='\n  <div class="panel">\n    <div class="accordion-heading '+
((__t=( abAccordionClass ))==null?'':__t)+
' collapsed" role="tab" data-toggle="collapse" href="#ldp-collapsed-transit" aria-expanded="false" aria-controls="ldp-collapsed-transit" data-omtag="ldp:transit:expand">\n      <h2 class="title-section '+
((__t=( abTitleClass ))==null?'':__t)+
' accordion-title">\n        <i class="ra ra-transit-train '+
((__t=( abIconClass ))==null?'':__t)+
'"></i>Transit\n      </h2>\n    </div>\n    <div id="ldp-collapsed-transit" class="panel-collapse collapse" role="tabpanel" aria-labelledby="ldpcollapseTransit">\n      <div class="panel-body">\n        <div class="listing-subsection ">\n          '+
((__t=( JST['templates/building_transit_options']({ transitOptions }) ))==null?'':__t)+
'\n        </div>\n      </div>\n    </div>\n  </div>\n';
 } else { 
__p+='\n  <h2 class="ldp-title-section"><i class="ra ra-transit-train"></i>Transit</h2>\n  '+
((__t=( JST['templates/building_transit_options']({ transitOptions }) ))==null?'':__t)+
'\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/building_transit_widget.jst.ejs